(() => {
  if (customElements.get('tf-workout-videos')) return;
  customElements.define('tf-workout-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.listenerController = new AbortController();
      const { signal } = this.listenerController;
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          const panel = panels[i];
          panel.hidden = i !== index;
          const frame = panel.querySelector('iframe');
          if (frame && i !== index) frame.remove();
          if (i === index && !frame) {
            const player = document.createElement('iframe');
            player.src = panel.dataset.video;
            player.title = tab.textContent.trim();
            player.loading = 'lazy';
            player.allow = 'encrypted-media; picture-in-picture; fullscreen';
            player.allowFullscreen = true;
            player.referrerPolicy = 'strict-origin-when-cross-origin';
            panel.prepend(player);
          }
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index), { signal });
        tab.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey) return;
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        }, { signal });
      });
      if (tabs.length) select(0);
      document.addEventListener('shopify:block:select', event => {
        if (!this.isConnected) return;
        const index = panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
        if (index >= 0) select(index);
      }, { signal });
    }
    disconnectedCallback() {
      this.listenerController?.abort();
      this.initialized = false;
    }
  });
})();
